const AOS = require('aos');

$(function(){
  AOS.init();
});